<div class="editgrid-resource-wrapper" (resized)="onResized($event)">
  <formio-loader *ngIf="customOptions?.showLoader"></formio-loader>
  <div
    fxLayout="row"
    [max]="60"
    fxLayoutAlign="end stretch"
    style="height: 100%"
    appSplit="row"
  >
    <div
      fxFlex="{{ modifyInDialog ? 100 : 50 }}"
      [fxFlex.sm]="modifyInDialog ? 100 : 50"
      [fxFlex.xs]="100"
      [fxHide.xs]="windowProperties.open"
      [fxHide]="windowProperties.fullscreen"
      appSplitArea
      class="resizeable-pane list-pane spliterContaienr"
    >
      <div class="flex action-header">
        <label class="control-label">
          <ng-container *ngIf="name">
            {{ "forms.common." + name | translate }}
          </ng-container>
        </label>

        <div>
          <button
            *ngIf="isEnableAdd"
            class="btn btn-outline-primary editgrid-add-btn btn-sm mb-2"
            (click)="openContent($event)"
            title="{{ 'forms.common.Add Another' | translate }}"
            role="button"
          >
            <span class="fa fa-plus" aria-hidden="true"></span>
          </button>
          <button
            class="btn btn-outline-primary editgrid-add-btn search btn-sm mb-2"
            *ngIf="filterCols?.length || formFilterKey"
            (click)="filterIsOpen = !filterIsOpen"
            title="{{ 'forms.common.Search Criteria' | translate }}"
            role="button"
          >
            <span
              class="fa fa-{{ filterIsOpen ? 'close' : 'filter' }}"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </div>
      <mat-accordion
        class="filterContent"
        *ngIf="formFilterKey || filterCols?.length"
      >
        <mat-expansion-panel [expanded]="filterIsOpen">
          <ng-container *ngIf="formFilterKey; else normalFilter">
            <formio
              #formFilter
              [formKey]="formFilterKey"
              [submission]="filterFormData"
              [readOnly]="false"
              (customEvent)="onFiterCustomEvent($event)"
              [options]="{ language: formioComponent?.i18next?.language }"
            >
            </formio>
          </ng-container>
          <ng-template #normalFilter>
            <div class="row">
              <div class="col-sm-6" *ngFor="let item of filterCols">
                <div class="form-group">
                  <label class="control-label">{{
                    "forms.common." + item.key | translate
                  }}</label>
                  <input
                    class="form-control"
                    name="{{ item.key }}"
                    [(ngModel)]="item.value"
                  />
                </div>
              </div>
            </div>

            <div class="filterControl">
              <button
                class="search"
                mat-raised-button
                type="button"
                (click)="applyFilter()"
                title="{{ 'forms.common.Search' | translate }}"
              >
                <i class="fa fa-search btn-icon" aria-hidden="true"></i>
              </button>
              <button
                class="reset"
                mat-raised-button
                type="button"
                (click)="reset()"
                title="{{ 'forms.common.Reset' | translate }}"
              >
                <i class="fa fa-refresh btn-icon" aria-hidden="true"></i>
              </button>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>

      <ng-container *ngIf="!editGridItems.length">
        <ng-container *ngIf="!isDesktopDevice; else desktopView">
          <div
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <mat-icon class="mat-icon-empty">storage</mat-icon>
            <br />
            {{ "forms.common.No items added yet" | translate }}
          </div>
        </ng-container>
        <ng-template #desktopView>
          <div
            class="editgrid-no-data"
            id="editgrid-no-data-ez1knex"
            style="display: block"
          >
            {{ "forms.common.No items added yet" | translate }}
          </div>
        </ng-template>
        <p class="error" *ngIf="required">
          {{ "forms.common.You must add at least one item" | translate }}
        </p>
      </ng-container>

      <ng-container *ngIf="filteredItems.length">
        <ng-container *ngIf="!isDesktopDevice; else desktopView">
          <div class="d-flex list-cards-container">
            <ng-container *ngFor="let item of filteredItems">
              <mat-card [style.width]="customOptions.cardWidth || '200px'">
                <mat-icon [matMenuTriggerFor]="actions" class="cardOption"
                  >more_vert</mat-icon
                >
                <div
                  *ngFor="let col of showColumns"
                  class="d-flex align-items-center mb-2 {{ col?.styleClass }}"
                >
                  <mat-icon class="hint-icon">{{
                    col?.icon || "text_fields"
                  }}</mat-icon>
                  <div class="d-flex flex-column two-line">
                    <label class="control-label">
                      <ng-container *ngIf="col.label; else showByKey">
                        <ng-container
                          *ngIf="col.disabledTtranslateHeader; else showLabel"
                        >
                          {{ col.label }}
                        </ng-container>
                        <ng-template #showLabel>
                          {{ "forms.common." + col.label | translate }}
                        </ng-template>
                      </ng-container>
                      <ng-template #showByKey>
                        <ng-container
                          *ngIf="col.disabledTtranslateHeader; else showKey"
                        >
                          {{ col.key }}
                        </ng-container>
                        <ng-template #showKey>
                          {{ "forms.common." + col.key | translate }}
                        </ng-template>
                      </ng-template>
                    </label>
                    <span>
                      <ng-container *ngIf="col.isFile; else textOrDate">
                        <div>
                          <a
                            class="editgrid-file cursor-pointer"
                            *ngFor="
                              let file of item.data[col.key + 'Evaluated']
                            "
                            (click)="openFile(file)"
                          >
                            <span>
                              {{ file.originalName }}
                            </span>
                          </a>
                        </div>
                      </ng-container>

                      <ng-template #textOrDate>
                        <ng-container *ngIf="col.dateFormat; else normal">
                          <div>
                            {{
                              item.data[col.key + "Evaluated"]
                                | date : col.dateFormat
                            }}
                          </div>
                        </ng-container>
                        <ng-template #normal>
                          <div
                            *ngIf="
                              item.data[col.key] && col.cssClass;
                              else showValue
                            "
                          >
                            <span class="{{ col.cssClass }}"></span>
                          </div>
                          <ng-template #showValue>
                            <div>{{ item.data[col.key + "Evaluated"] }}</div>
                          </ng-template>
                        </ng-template>
                      </ng-template>
                    </span>
                  </div>
                </div>
              </mat-card>
              <mat-menu
                #actions="matMenu"
                [yPosition]="customOptions.menuYPosition || 'below'"
              >
                <button
                  mat-menu-item
                  *ngIf="isEnableView"
                  (click)="openContent($event, item, true)"
                >
                  {{ "forms.common.Details" | translate }}
                  <span class="p-button-icon fa fa-eye ml-1"></span>
                </button>
                <button
                  mat-menu-item
                  *ngIf="isEnableEdit"
                  (click)="openContent($event, item)"
                >
                  {{ "forms.common.Edit" | translate }}
                  <span class="p-button-icon fa fa-edit ml-1"></span>
                </button>
                <button
                  mat-menu-item
                  *ngIf="isEnableDelete"
                  (click)="deleteContent(item)"
                >
                  {{ "forms.common.delete" | translate }}
                  <span class="p-button-icon fa fa-trash ml-1"></span>
                </button>

                <ng-container *ngFor="let action of externalActions">
                  <button
                    mat-menu-item
                    (click)="doAction(action, item, $event)"
                    [appDisplayExternalActions]="action.displayAction"
                    [row]="item"
                    [submission]="data"
                  >
                    {{ action.label | translate }}
                    <span class="p-button-icon {{ action.icon }} ml-1"></span>
                  </button>
                </ng-container>
              </mat-menu>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #desktopView>
          <p-table
            [value]="filteredItems"
            responsiveLayout="scroll"
            [paginator]="customOptions?.enablePagination"
            [rows]="limit"
            [totalRecords]="totalRecords"
            [lazy]="customOptions?.enablePagination"
            (onLazyLoad)="loadPage($event)"
          >
            <ng-template pTemplate="header">
              <tr>
                <th *ngIf="enableSelected"></th>
                <th *ngFor="let col of showColumns">
                  <div *ngIf="col.label; else showByKey">
                    <ng-container
                      *ngIf="col.disabledTtranslateHeader; else showLabel"
                    >
                      {{ col.label }}
                    </ng-container>
                    <ng-template #showLabel>
                      {{ "forms.common." + col.label | translate }}
                    </ng-template>
                  </div>
                  <ng-template #showByKey>
                    <div>
                      <ng-container
                        *ngIf="col.disabledTtranslateHeader; else showLabel"
                      >
                        {{ col.key }}
                      </ng-container>
                      <ng-template #showLabel>
                        {{ "forms.common." + col.key | translate }}
                      </ng-template>
                    </div>
                  </ng-template>
                </th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <!-- Checkbox column -->
                <td *ngIf="enableSelected">
                  <ng-container>
                    <input
                      type="checkbox"
                      [checked]="isChecked(item._id)"
                      (change)="onCheckboxChange(item, $event)"
                    />
                  </ng-container>
                </td>
                <td *ngFor="let col of showColumns" [class]="col?.styleClass">
                  <ng-container *ngIf="col.isFile; else textOrDate">
                    <div class="one-row">
                      <a
                        class="editgrid-file cursor-pointer"
                        *ngFor="let file of item.data[col.key + 'Evaluated']"
                        (click)="openFile(file)"
                      >
                        <span class="icon"></span>
                        {{ file.originalName }}
                      </a>
                    </div>
                  </ng-container>

                  <ng-template #textOrDate>
                    <ng-container *ngIf="col.dateFormat; else normal">
                      <div>
                        {{
                          item.data[col.key + "Evaluated"]
                            | date : col.dateFormat
                        }}
                      </div>
                    </ng-container>
                    <ng-template #normal>
                      <div
                        *ngIf="
                          item.data[col.key] && col.cssClass;
                          else showValue
                        "
                      >
                        <span class="{{ col.cssClass }}"></span>
                      </div>
                      <ng-template #showValue>
                        <div>{{ item.data[col.key + "Evaluated"] }}</div>
                      </ng-template>
                    </ng-template>
                  </ng-template>
                </td>
                <td>
                  <div>
                    <button
                      *ngIf="isEnableView"
                      class="p-button p-button-text p-button-sm p-button-secondary p-button-rounded p-button-icon-only"
                      (click)="openContent($event, item, true)"
                      title="{{ 'forms.common.Details' | translate }}"
                    >
                      <span class="p-button-icon fa fa-eye"></span>
                    </button>

                    <button
                      *ngIf="isEnableEdit"
                      class="p-button p-button-text p-button-secondary p-button-sm p-button-rounded p-button-icon-only"
                      (click)="openContent($event, item)"
                      title="{{ 'forms.common.Edit' | translate }}"
                    >
                      <span class="p-button-icon fa fa-edit"></span>
                    </button>

                    <button
                      *ngIf="isEnableDelete"
                      class="p-button p-button-text p-button-danger p-button-sm p-button-rounded p-button-icon-only"
                      (click)="deleteContent(item)"
                      title="{{ 'forms.common.delete' | translate }}"
                    >
                      <span class="p-button-icon fa fa-trash"></span>
                    </button>

                    <ng-container *ngFor="let action of externalActions">
                      <button
                        [appDisplayExternalActions]="action.displayAction"
                        [row]="item"
                        [submission]="data"
                        class="p-button p-button-text p-button-secondary p-button-sm p-button-rounded p-button-icon-only"
                        (click)="doAction(action, item, $event)"
                        title="{{ action.label | translate }}"
                      >
                        <span class="p-button-icon {{ action.icon }}"></span>
                      </button>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template
              pTemplate="paginatorleft"
              let-state
              *ngIf="customOptions?.enablePagination"
            >
              {{ state.page + 1 }} {{ "forms.common.From" | translate }}
              {{ state.pageCount }}
            </ng-template>
          </p-table>
        </ng-template>
      </ng-container>
    </div>

    <ng-container *ngIf="!modifyInDialog">
      <div
        [hidden]="windowProperties.fullscreen"
        class="handle hide-xs spliterIcon"
        appSplitHandle
      >
        <mat-icon>drag_indicator</mat-icon>
      </div>
      <div
        [fxFlex]="50"
        [fxFlex.sm]="50"
        [fxFlex.xs]="100"
        [fxHide.xs]="!windowProperties.open"
        [ngClass]="{ fullscreen: windowProperties.fullscreen }"
        appSplitArea
        class="resizeable-pane spliterContaienr"
      >
        <add-edit-editgrid-content
          *ngIf="currentItem"
          [data]="currentItem"
          (close)="closeActive($event)"
        >
        </add-edit-editgrid-content>
      </div>
    </ng-container>
  </div>
</div>
